import FormGuardPlugin from "@upmind/formguard/vue2";
import Axios from "axios";
import $store from "@/store";

export default {
  install(Vue: Parameters<typeof FormGuardPlugin.install>[0]) {
    FormGuardPlugin.install(Vue, {
      axios: Axios,
      baseUrl: "https://backup-api.upmind.dev",
      skipGrantTypes: ["twofa-admin"],
      onError: () => {
        $store.dispatch("toast/error", {
          message:
            "Login protection is temporarily unavailable. Please refresh the page and try again."
        });
      }
    });
  }
};
